// extracted by mini-css-extract-plugin
export var sliderRange = "_ny-2";
export var sliderRoot = "_ny-0";
export var sliderThumb = "_ny-3";
export var sliderTrack = "_ny-1";